import React from 'react'
import CountryDetailsLeft from './Components/CountryDetailsLeft'
import CountryDetailsCenter from './Components/CountryDetailsCenter'
import CountryDetailsRight from './Components/CountryDetailsRight'
import './_styles.scss'

/**
 * CountryDetailsHeader
 * Cabecera de la modal de detalle de país.
 * Estructura y estilos base tomados de MatchDetailHeader.
 * Diseño: Figma node 126:17590 — Large/Cards/Equipo
 *
 * Props:
 *  name    {string} — nombre del país
 *  crestUrl {string} — logo del equipo/país
 *  flagUrl {string} — bandera del país
 *  color   {string} — color del equipo para la barra superior y el borde del logo
 *  matches {number} — cantidad de partidos jugados
 *  points  {number} — puntos en la tabla
 */

// function CountryDetailsHeader ({ name, crestUrl, flagUrl, color, matches, points, isFavorited, dataHeader }) {
function CountryDetailsHeader ({ dataHeader, countryId, onClickFavorite }) {

  const { transformedTeam: { name, crestUrl, flagUrl, color, matches, isFavorited } = {}, transformedRecentResults, transformedFeaturedPlayers, summary } = dataHeader || {}
  const hasDataHeaderContent = dataHeader && Object.keys(dataHeader).length > 0

  return (
    <div
      className='country-details-header'
    >
      <div className='country-details-header__color-bar' style={{ background: color || '#ffffff' }} />
      {/* Left section — logo, bandera, nombre, últimos partidos */}
      <CountryDetailsLeft name={name} color={color} crestUrl={crestUrl} flagUrl={flagUrl} recentResults={transformedRecentResults} />

      {/* Divisor izquierdo */}
      { hasDataHeaderContent && <div className='country-details-header__divider country-details-header__divider--left' /> }

      {/* Center section — favorito, jugadores destacados */}
      <CountryDetailsCenter 
        color={color} 
        isFavorited={isFavorited} 
        featuredPlayers={transformedFeaturedPlayers} 
        countryId={countryId} 
        onClickFavorite={onClickFavorite} 
      />

      {/* Divisor derecho */}
      { hasDataHeaderContent && <div className='country-details-header__divider country-details-header__divider--right' /> }

      {/* Right section — estadísticas */}
      { hasDataHeaderContent && <CountryDetailsRight matches={summary && summary.matches} points={summary && summary.points} /> }
    </div>
  )
}

export default CountryDetailsHeader



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsHeader/index.jsx